import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgChevronRight({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.583 12l-5.29-5.293a1 1 0 111.414-1.414l5.997 6a.997.997 0 010 1.414l-5.997 6a1 1 0 01-1.414-1.414L14.583 12z"
        fill={color}
      />
    </svg>
  )
}

export default SvgChevronRight
